import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { ISimpleHeroBlockProps } from "./SimpleHeroBlock.props";

export const SimpleHeroBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  headingEffect,
  parentClass,
  spacing,
}: ISimpleHeroBlockProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;

  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="daylight-work-surface relative isolate flex min-h-[24rem] items-end overflow-hidden rounded-[14px] px-7 py-12 md:px-14 md:py-16 lg:px-20 lg:py-20">
        <div aria-hidden="true" className="signal-grid-lines absolute inset-0 opacity-[0.14]" />
        <DaylightCommonContent
          alignment={alignment}
          buttons={buttons}
          className="relative z-10"
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingEffect={headingEffect}
          headingAs="h1"
          headingClassName="max-w-[14ch] text-[clamp(2.5rem,6vw,4.25rem)] leading-[0.96] tracking-[-0.04em]"
          reveal
          revealHeading="wipe"
        />
      </div>
    </DaylightSection>
  );
};

SimpleHeroBlock.displayName = "Block::SimpleHeroBlock";
